import { render } from "./SpinnerLottieComponent.vue?vue&type=template&id=21065566&scoped=true"
import script from "./SpinnerLottieComponent.vue?vue&type=script&lang=js"
export * from "./SpinnerLottieComponent.vue?vue&type=script&lang=js"

import "./SpinnerLottieComponent.vue?vue&type=style&index=0&id=21065566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21065566"]])

export default __exports__